// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { IEmployeeScheduledContributionDto } from './IEmployeeScheduledContributionDto';
import {
    IEmployeeScheduledContributionDtoFromJSON,
    IEmployeeScheduledContributionDtoFromJSONTyped,
    IEmployeeScheduledContributionDtoToJSON,
    IEmployeeScheduledContributionDtoToJSONTyped,
} from './IEmployeeScheduledContributionDto';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageEmployeeScheduledContributionDto
 */
export interface IPageEmployeeScheduledContributionDto {
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IEmployeeScheduledContributionDto>}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    content?: Array<IEmployeeScheduledContributionDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEmployeeScheduledContributionDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageEmployeeScheduledContributionDto interface.
 */
export function instanceOfIPageEmployeeScheduledContributionDto(value: object): value is IPageEmployeeScheduledContributionDto {
    return true;
}

export function IPageEmployeeScheduledContributionDtoFromJSON(json: any): IPageEmployeeScheduledContributionDto {
    return IPageEmployeeScheduledContributionDtoFromJSONTyped(json, false);
}

export function IPageEmployeeScheduledContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageEmployeeScheduledContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IEmployeeScheduledContributionDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageEmployeeScheduledContributionDtoToJSON(json: any): IPageEmployeeScheduledContributionDto {
    return IPageEmployeeScheduledContributionDtoToJSONTyped(json, false);
}

export function IPageEmployeeScheduledContributionDtoToJSONTyped(value?: IPageEmployeeScheduledContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IEmployeeScheduledContributionDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

